import Promise from 'bluebird';
import { createOrUpdateCampaign, createOrUpdateAssetGroup } from '@bingads-webui-campaign-react/perf-max-data';

export const updateAssetGroupAndCampaignStatus = ({ campaignId, assetGroupId }) => {
  const campaignData = {
    Id: campaignId,
    Status: 'Active',
  };

  const assetGroupData = {
    Id: assetGroupId,
    Status: 'Active',
    Campaign: {
      Id: campaignId,
    },
  };

  return Promise.props({
    campaign: createOrUpdateCampaign(campaignData),
    assetGroup: createOrUpdateAssetGroup(assetGroupData),
  });
};
